
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./FilesPage": () => {
return Promise.all(/*  | __federation_expose_FilesPage */ [__webpack_require__.e("6969"), __webpack_require__.e("7638"), __webpack_require__.e("8800"), __webpack_require__.e("1779"), __webpack_require__.e("6603"), __webpack_require__.e("8773"), __webpack_require__.e("9949")]).then(() => (() => (__webpack_require__(19409))));
},
"./SharedFolderPage": () => {
return Promise.all(/*  | __federation_expose_SharedFolderPage */ [__webpack_require__.e("6969"), __webpack_require__.e("7638"), __webpack_require__.e("1779"), __webpack_require__.e("6603"), __webpack_require__.e("8773"), __webpack_require__.e("5631")]).then(() => (() => (__webpack_require__(98965))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };